// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"6e5e56e8","171":"8a391cdc","191":"3d450943","444":"7d02c3a9","453":"11d3d400","969":"e14452e8"}[chunkId] + ".chunk.js";
};